import axios, { getData } from 'lib/axios'

export const getAppliedCourse = async (per_page, page) => {
  const response = await axios.get(
    `/upskilling/applied-upskilling-claim?per-page=${per_page}&page=${page}`
  )
  return getData(response)
}
export const getOneAppliedCourse = async (id) => {
  const response = await axios.get(`/upskilling/applied-upskilling-claim/${id}`)
  return getData(response)
}
// unapplied course
export const getCourseAvailable = async () => {
  const response = await axios.get(`/upskilling/unclaim-upskilling-course`)
  return getData(response)
}
export const getRecommendedCourse = async () => {
  const response = await axios.get(`/upskilling/available-course-list?per-page=3`)
  return getData(response)
}
export const postCourse = async (data) => {
  const response = await axios.post(`/upskilling/apply-upskilling-claim`, data)
  return getData(response)
}
